var option_webview_default = {
  "option": "eLOMt",
  "user_choice": "IPVPd",
  "check": "_25H0s",
  "image": "rNc4z",
  "input": "_1a41b",
  "title": "ecibc",
  "centered": "TsioW",
  "with_result": "hDUE-",
  "list": "_2xFr3",
  "with_image": "_8I-yP",
  "progress": "LlSju",
  "progress_value": "_6nMAH",
  "label": "QfTuJ",
  "cta": "my9dl",
  "adornment_icon": "iGXhf",
  "remove": "_9EmpC",
  "removeButton": "gxWgc",
  "removeButtonIcon": "zvnD3",
  "overlay": "xmspB",
  "shown": "eMpVb",
  "dark": "SCFxN",
  "spinner": "F1655",
  "spin": "EWTjG",
  "grid": "Q9XcL"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
